module.exports = __webpack_public_path__ + "static/media/IMG_4201.8fb3c258.JPG";